import { BodyLarge } from '@casavo/base-ui'
import { useField } from 'formik'
import useTranslation from 'next-translate/useTranslation'
import { useEffect, useRef, useState } from 'react'

import { ButtonCarousel, CarouselRef } from '@/components/ButtonCarousel'
import type { Option } from '@/components/ButtonCarousel'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { marginBottom } from '@/shared-styles/styles.css'
import { getSlotsFromDate, mapSlotToLabelValue, Slot } from '@/utils/slot-utils'

import { slotOuter } from './styles.css'

type Props = {
  dateList: Option[]
  isVisitRequestType: boolean
}

export const RequestContactSlot: React.FC<Props> = ({ dateList, isVisitRequestType }) => {
  const [timeSlotList, setTimeSlotList] = useState<Slot[]>([])
  const [isSlotDateUpdated, setIsSlotDateUpdated] = useState<boolean>(false)
  const [dateSlotRef, timeSlotRef] = [useRef<CarouselRef>(null), useRef<CarouselRef>(null)]
  const [_, { error: errorDate, touched: touchedDate, value: dateValue }, { setValue: setDateValue }] =
    useField<string>('date')
  const [__, { error: errorSlot, touched: touchedSlot, value: slotValue }, { setValue: setSlotValue }] =
    useField('hourRange')

  useEffect(() => {
    const slotList = getSlotsFromDate(new Date(dateValue), !isVisitRequestType)
    setTimeSlotList(slotList)
  }, [dateValue, isVisitRequestType])

  const { t } = useTranslation()

  const onSelectedDate = (d: { date: Date; label: string; value: string }) => {
    setIsSlotDateUpdated(true)
    setDateValue(d.date.toISOString())
    setSlotValue('')
    timeSlotRef.current?.resetScroll()
  }

  const onSelectedSlot = (d: { date: Slot; label: string; value: string }) => {
    setSlotValue(d.value)
  }

  return (
    <div className={slotOuter}>
      <BodyLarge strong className={marginBottom.m}>
        {isVisitRequestType ? t('listing-detail:select_request_visit_date') : t('listing-detail:select_call_date')}
      </BodyLarge>
      <ButtonCarousel
        ref={dateSlotRef}
        className={sprinkles({ marginBottom: '3xl' })}
        error={errorDate}
        name="dayRange"
        options={dateList}
        touched={touchedDate}
        value={dateValue}
        onSelectedItem={onSelectedDate}
      />

      {isSlotDateUpdated && (
        <>
          <BodyLarge strong className={marginBottom.m}>
            {isVisitRequestType ? t('listing-detail:select_visit_time') : t('listing-detail:select_call_time')}
          </BodyLarge>
          <ButtonCarousel
            ref={timeSlotRef}
            error={errorSlot}
            name="hourRange"
            options={mapSlotToLabelValue(timeSlotList)}
            touched={touchedSlot}
            value={slotValue}
            onSelectedItem={onSelectedSlot}
          />
        </>
      )}
    </div>
  )
}
